import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import { useNavigate } from 'react-router-dom';
import DiscountCouponService from "../../pages/DiscountCoupon/Discountcoupons.service";
import AuthService from "../../pages/Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import PermissionAccess from '../../PermissionAccess/Access.js';

const Input = styled.input.attrs(props => ({
  type: "text",
  size: props.small ? 5 : undefined
}))`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border: 1px solid var(--buttons-color, #30b1ff);
  padding: 0 32px 0 16px;
  justify-content: flex-start;
`;

const Select = styled.select`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border: 1px solid var(--buttons-color, #30b1ff);
  margin-left: 10px;
  padding: 0 16px;
`;

const Button = styled.button`
  margin-left: 2%;
  type: button;
  class: btn btn-custom-color btn-hover-shine me-3 btn;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DocumentSettingsFilter = ({ onClear, onSearch }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [status, setStatus] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [specializationOptions, setSpecializationOptions] = useState([]);
  const { authData } = PermissionAccess();

  useEffect(() => {
    const fetchSpecializations = async () => {
      DiscountCouponService.getAllSpecializations(authData.sessionID, 0, 9999999, '', '', '', false)
        .then((response) => {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          } else if (response.data.status === true) {
            const options = response.data.data.map(spec => ({
              value: spec._id,
              label: spec.name
            }));
            setSpecializationOptions(options);
          } else {
            Alerts.swalErrorAlert(t("Something went wrong, Please try again."));
          }
        })
        .catch((error) => {
          const errContent = (error.response && error.response.data) || error.message || error.toString();
          Alerts.swalErrorAlert(errContent || t("Server Error, Please try again later."));
        });
    };
    fetchSpecializations();
  }, [authData.sessionID, navigate, t]);

  const handleClear = () => {
    onClear();
    setSearchText('');
    setStatus('');
    setSpecialization('');
  };

  const handleSearch = () => {
    onSearch(searchText, status, specialization);
  };

  return (
    <Container>
      <Input
        type="text"
        placeholder={t('Search Text')}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      <Select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="">{t('Select Status')}</option>
        <option value="Active">{t('Active')}</option>
        <option value="InActive">{t('InActive')}</option>
      </Select>

      <Select
        value={specialization}
        onChange={(e) => setSpecialization(e.target.value)}
      >
        <option value="">{t('Select Specialization')}</option>
        {specializationOptions.map(option => (
          <option key={option.value} value={option.value}>{t(option.label)}</option>
        ))}
      </Select>

      <Button className="btn btn-custom-color btn-hover-shine me-3 btn" onClick={handleSearch}>
        {t('Search')}
      </Button>
      <Button className="btn btn-custom-color btn-hover-shine me-3 btn" onClick={handleClear}>
        {t('Reset')}
      </Button>
    </Container>
  );
};

export default DocumentSettingsFilter;
